import type { FormInputType } from '@/components/UI/Form/types'

export function getRequestVolunteerActivityChangesFormInputs(): FormInputType[] {
  return [
    {
      name: 'reason',
      type: 'textarea',
      label: 'Reason',
      sublabel: 'Please include why you are requesting changes to this logged Volunteer Activity',
      required: true,
      size: 6,
    },
  ]
}
